export const months = [
  {key: 'Jan', value: 'January'},
  {key: 'Feb', value: 'February'},
  {key: 'Mar', value: 'March'},
  {key: 'Apr', value: 'April'},
  {key: 'May', value: 'May'},
  {key: 'Jun', value: 'June'},
  {key: 'Jul', value: 'July'},
  {key: 'Aug', value: 'August'},
  {key: 'Sep', value: 'September'},
  {key: 'Oct', value: 'October'},
  {key: 'Nov', value: 'November'},
  {key: 'Dec', value: 'December'},
];
